import { ref, computed } from 'vue'

const state = ref({
    lastUserFetched: null,
    cart: [],
    user: null,
    tax_exempt: false,
    isFetching: false,
});

export default function UseCart (user, tax_exempt) {
    state.value.user = user;
    state.value.tax_exempt = tax_exempt;

    const fetchCart = async function () {
        try {
            state.value.isFetching = true;
            const response = await axios.get(route('cart'));
            state.value.cart = response.data;
            state.value.isFetching = false;
        } catch (error) {
            state.value.lastUserFetched = null;
        }
    };

    const saveCart = _.debounce(function () {
        axios.post(route('cart'), {
            items: { ...state.value.cart },
        }).then((response) => {
            if (response.data !== 'success' && response.request.responseURL) {
                window.location = response.request.responseURL;
            }
        }).catch(error => {
            console.log(error);
        });
    }, 250);

    const updateCart = function (product, quantity) {
        if (quantity > 0) {
            const cartItem = state.value.cart.find(item => item.product.id === product.id);

            if (cartItem) {
                cartItem.quantity = quantity;
            } else {
                state.value.cart.push({
                    quantity,
                    product,
                    price: product.price,
                });
            }
        } else {
            const cartIndex = state.value.cart.findIndex(item => item.product.id === product.id);

            if (cartIndex !== -1) {
                state.value.cart.splice(cartIndex, 1);
            }
        }

        saveCart();
    };

    const emptyCart = () => {
        state.value.cart.splice(0, state.value.cart.length);

        saveCart();
    };

    const cartSubtotal = computed(() => {
        const total = state.value.cart.reduce((carry, item) => carry += (item.price * item.quantity), 0);

        return Math.round(total * 100) / 100;
    });

    const cartTax = computed(() => {
        if (state.value.tax_exempt) return 0;

        const total = state.value.cart.reduce((carry, item) => {
            if (item.product.taxable) {
                carry += Number(item.price) * Number(item.quantity) * 0.13;
            }

            return carry;
        }, 0);

        return Math.round(total * 100) / 100;
    });

    const cartTotal = computed(() => {
        const total = cartTax.value + cartSubtotal.value;

        return Math.round(total * 100) / 100;
    });

    const cartCount = computed(() => state.value.cart.reduce((carry, item) => carry += item.quantity, 0));

    const cartHasSpecialOrderItems = computed(() => state.value.cart.filter(item => item.product.special_order === true).length > 0 ? true : false);

    const cartCategories = computed(() => new Set(state.value.cart.map(c => { return c.product.category_id})));

    return {
        isFetching: computed(() => state.value.isFetching),
        cart: computed(() => state.value.cart),
        cartSubtotal,
        cartTax,
        cartTotal,
        cartCount,
        cartHasSpecialOrderItems,
        cartCategories,
        updateCart,
        emptyCart,
        fetchCart,
    }
}
